var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWheelchairUnknownOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "#808080"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.476 12.658H9.244a6.376 6.376 0 01-.014-.49c0-.933.387-1.661 1.162-2.184l.616-.42c.495-.336.742-.793.742-1.372 0-.448-.145-.826-.434-1.134-.29-.308-.7-.462-1.232-.462-.57 0-1.003.177-1.302.532a1.894 1.894 0 00-.448 1.26c0 .28.033.509.098.686l-1.358-.168a2.45 2.45 0 01-.084-.672c0-.457.103-.896.308-1.316.205-.42.55-.784 1.036-1.092.485-.308 1.069-.462 1.75-.462.933 0 1.675.28 2.226.84.56.56.84 1.218.84 1.974 0 .98-.476 1.792-1.428 2.436l-.644.434c-.41.28-.616.728-.616 1.344 0 .084.005.173.014.266zm-1.274 2.646a.877.877 0 01-.266-.644c0-.252.089-.467.266-.644a.856.856 0 01.644-.28c.252 0 .467.093.644.28.187.177.28.392.28.644a.855.855 0 01-.28.644.877.877 0 01-.644.266.877.877 0 01-.644-.266z",
    fill: "#808080"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchairUnknownOutline);
export default __webpack_public_path__ + "static/media/wheelchair-unknown-outline.de89ab86.svg";
export { ForwardRef as ReactComponent };